<div fxLayout="row" fxLayoutAlign="center center">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>